import { LICENSING_SELECTION_CHANGE, log } from "./LicensingSelector";

/** The label+dropdown for e.g. number of users */

export class OptionSelector {
  /**
   * Instantiate the relevant class, either dropdown or radio.
   */
  static fromElement(element) {
    if (element.querySelector("select")) {
      return new DropdownOptionSelector(element);
    }
    return new RadioOptionSelector(element);
  }

  constructor(element) {
    this.element = element;
    this.id = safeParseInt(element.dataset.licensingOptionGroupId);
    this.log = log.extend(`${this.constructor.name}:${this.id}`);
    this.log("Creating option group box", element);
    /** @type {number | null} */
    this.selectedOptionId = null;
  }

  disconnect() {}

  notifySelectionChanged() {
    this.selectedOptionId = this.getSelectedOptionId();
    this.element.dispatchEvent(
      new CustomEvent(LICENSING_SELECTION_CHANGE, { bubbles: true })
    );
  }

  /** @returns {number | null} */
  getSelectedOptionId() {
    return null;
  }
}

// ------------------------------------------------------------
//   DROPDOWN
// ------------------------------------------------------------
export class DropdownOptionSelector extends OptionSelector {
  /** @type {HTMLSelectElement | null} */
  selectElement;

  constructor(element) {
    super(element);
    this.selectElement = element.querySelector("select");
    this.selectedOptionId = this.getSelectedOptionId();
    this._handleSelectionChange = () => this.notifySelectionChanged();
    if (this.selectElement) {
      this.selectElement.addEventListener(
        "change",
        this._handleSelectionChange
      );
    }
  }

  disconnect() {
    if (this.selectElement && this._handleSelectionChange) {
      this.selectElement.removeEventListener(
        "change",
        this._handleSelectionChange
      );
    }
  }

  getSelectedOptionId() {
    if (!this.selectElement) return null;
    const opt = this.selectElement.selectedOptions[0];
    return opt ? safeParseInt(opt.value) : null;
  }
}

// ------------------------------------------------------------
//   RADIOS
// ------------------------------------------------------------

export class RadioOptionSelector extends OptionSelector {
  /** @type {HTMLInputElement[]} */
  radioElements;

  constructor(element) {
    super(element);
    this.radioElements = Array.from(
      element.querySelectorAll("input[type='radio']")
    );
    this.selectedOptionId = this.getSelectedOptionId();
    this._handleSelectionChange = () => this.notifySelectionChanged();
    this.radioElements.forEach((radio) => {
      radio.addEventListener("change", this._handleSelectionChange);
    });
  }

  disconnect() {
    if (!this._handleSelectionChange) return;
    this.radioElements.forEach((radio) =>
      radio.removeEventListener("change", this._handleSelectionChange)
    );
  }

  getSelectedOptionId() {
    if (this.radioElements.length === 0) return null;
    return safeParseInt(
      this.radioElements.find((radio) => radio.checked)?.value
    );
  }
}

export function safeParseInt(value) {
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? null : parsed;
}
